import '../App.sass';

interface Properties {
  title: string;
  className?: string;
  color?: string;
  value: string;
  unit?: string;
  onClick?: () => void;
  size?: 'default' | 'large';
}

export default function Metric(properties: Properties) {
  const getComputedColor = (colorValue?: string) => {
    if (!colorValue) return undefined;
    
    // If it's a CSS variable, get its computed value
    if (colorValue.startsWith('var(--')) {
      const variableName = colorValue.replace('var(--', '').replace(')', '');
      const computedStyle = getComputedStyle(document.documentElement);
      return computedStyle.getPropertyValue(`--${variableName}`).trim();
    }
    
    return colorValue;
  };

  const computedColor = getComputedColor(properties.color);

  const containerStyle: React.CSSProperties = {
    // Fill the (stretched) row height so the label stays top-aligned and the
    // value bottom-aligned; minHeight keeps the stretch visible in short rows.
    height: '100%',
    minHeight: properties.size === 'large' ? 96 : 72,
    ...(properties.onClick ? { cursor: 'pointer' } : {}),
  };

  const valueSizeClass = properties.size === 'large' ? 'textXXL' : 'textXL';
  const titleSizeClass = properties.size === 'large' ? 'textM' : 'textS';
  const containerWidth = properties.size === 'large' ? 'width200' : 'width150';

  return <div 
    className={`${properties.className ? properties.className + ' ' : ''}displayFlex flexDirectionColumn alignItemsCenter justifyContentSpaceBetween ${containerWidth}`}
    style={containerStyle}
    onClick={properties.onClick}
  >
    <div className={titleSizeClass} style={{ color: computedColor }}>{properties.title}</div>
    <div className='displayFlex alignItemsBaseline gapXS'>
      <span className={`${valueSizeClass} fontWeightBold headerFont`} style={{ color: computedColor }}>{properties.value}</span>
      {properties.unit
        ?
        <span className='textL fontWeightBold headerFont' style={{ color: computedColor }}>{properties.unit}</span>
        :
        <></>}
    </div>
  </div>;
}
